import { Skeleton } from '@/components/primitives';
import styles from './TitleProfile.module.css';

/**
 * Layout-matched loading state for the Title Profile. Mirrors the real page
 * structure (hero, KPI grid, two chart cards) so content swaps in without a
 * jarring reflow — far better than a centred spinner on an empty page.
 */
export function TitleProfileSkeleton() {
  return (
    <div className={styles.page} aria-busy="true" aria-label="Loading title profile">
      {/* Hero */}
      <div className={styles.hero}>
        <div className={styles.heroGradient} />
        <div className={styles.heroContent}>
          <Skeleton width={64} height={16} style={{ marginBottom: 'var(--space-4)' }} />
          <div className={styles.heroMain}>
            <Skeleton width={160} height={240} style={{ borderRadius: 'var(--radius-lg)' }} />
            <div className={styles.heroInfo}>
              <Skeleton width={360} height={40} />
              <Skeleton width={220} height={16} style={{ marginTop: 'var(--space-2)' }} />
            </div>
          </div>
        </div>
      </div>

      {/* KPI grid */}
      <div className={styles.kpiGrid}>
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className={styles.kpiCard}>
            <Skeleton width={18} height={18} shape="circle" />
            <Skeleton width={90} height={10} style={{ marginTop: 'var(--space-2)' }} />
            <Skeleton width={120} height={32} style={{ marginTop: 'var(--space-2)' }} />
            <Skeleton width={110} height={12} style={{ marginTop: 'var(--space-1)' }} />
          </div>
        ))}
      </div>

      {/* Chart cards */}
      <div className={styles.charts}>
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className={styles.skeletonCard}>
            <div className={styles.skeletonCardHeader}>
              <div>
                <Skeleton width={180} height={18} />
                <Skeleton width={140} height={12} style={{ marginTop: 'var(--space-2)' }} />
              </div>
              <Skeleton width={240} height={34} style={{ borderRadius: '24px' }} />
            </div>
            <Skeleton height={64} style={{ marginBottom: 'var(--space-4)' }} />
            <Skeleton height={300} />
          </div>
        ))}
      </div>
    </div>
  );
}
